/**
 * @file Shared React component — components/common/FormFieldLabel.tsx.
 */

import React from "react";
import FormFieldInfoTooltip from "./FormFieldInfoTooltip";
import "../../styles/infoText.css";

/** Type definition — Form Field Label Props. */
export interface FormFieldLabelProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  infoText?: string | null;
  className?: string;
  ensureQuestionMark?: boolean;
}

/**
 * Standard form field label (text + required * + info tooltip).
 * Used by TextInput, Dropdown, Background, Publication, etc.
 */
const FormFieldLabel: React.FC<FormFieldLabelProps> = ({
  label,
  htmlFor,
  required = false,
  infoText,
  className,
  ensureQuestionMark = false,
}) => {
  const trimmed = String(label ?? "").trim();
  const displayLabel =
    ensureQuestionMark && trimmed && !trimmed.endsWith("?")
      ? `${trimmed}?`
      : trimmed;

  const labelClassName = ["input-label", className].filter(Boolean).join(" ");

  return (
    <label htmlFor={htmlFor} className={labelClassName}>
      <span className="label-text">
        {displayLabel}
        {required && <span className="required">*</span>}
        <FormFieldInfoTooltip text={infoText} />
      </span>
    </label>
  );
};

/** React component — Form Field Label. */
export default FormFieldLabel;
